import { SvgIcon, SvgIconProps } from '@mui/material'
import { FC } from 'react'

export const DangerIcon: FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g id="vuesax/linear/danger">
        <g id="danger">
          <path
            id="Vector"
            d="M12 9.88794V14.8879"
            stroke="#13212F"
            strokeWidth="1.25"
            strokeLinecap="round"
            strokeLinejoin="round"
            fill="transparent"
          />
          <path
            id="Vector_2"
            d="M11.9994 22.298H5.93944C2.46944 22.298 1.01944 19.818 2.69944 16.788L5.81944 11.168L8.75944 5.88797C10.5394 2.67797 13.4594 2.67797 15.2394 5.88797L18.1794 11.178L21.2994 16.798C22.9794 19.828 21.5194 22.308 18.0594 22.308H11.9994V22.298Z"
            stroke="#13212F"
            strokeWidth="1.25"
            strokeLinecap="round"
            strokeLinejoin="round"
            fill="transparent"
          />
          <path
            id="Vector_3"
            d="M11.9941 17.8879H12.0031"
            stroke="#13212F"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            fill="transparent"
          />
        </g>
      </g>
    </SvgIcon>
  )
}
